/**
 * FinancialStatementSection Component
 *
 * Direct wrapper for FinStatement component (no extra collapse)
 * Maintains existing financial statement functionality with its own collapse
 */

import React from "react";
import FinStatement from "../../ExitFromUserDetails/FinStatement";

const FinancialStatementSection = ({
  data,
  fandftrigger,
  setFandfTrigger,
  isLocalExit,
  baseEndpoint,
  repatriationAmount,
  repatriationSaved,
  selectedRepatrationType,
  isPreviewMode,
  ffSettlementTotal,
}) => {
  return (
    <FinStatement
      data={data}
      fandftrigger={fandftrigger}
      setFandfTrigger={setFandfTrigger}
      isLocalExit={isLocalExit}
      baseEndpoint={baseEndpoint}
      repatriationAmount={repatriationAmount}
      repatriationSaved={repatriationSaved}
      ffSettlementTotal={ffSettlementTotal}
      selectedRepatrationType={selectedRepatrationType}
    />
  );
};

export default FinancialStatementSection;
